// extracted by mini-css-extract-plugin
export default {"home":"home_home__vwg4B","content":"home_content__IDPCE"};